import { render, staticRenderFns } from "./TenantNotFound.vue?vue&type=template&id=108a32f5&scoped=true"
import script from "./TenantNotFound.vue?vue&type=script&lang=js"
export * from "./TenantNotFound.vue?vue&type=script&lang=js"
import style0 from "./TenantNotFound.vue?vue&type=style&index=0&id=108a32f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108a32f5",
  null
  
)

export default component.exports